<template>
    <div>
        <div class="row no-gutters align-center justify-center mb-5" v-if="showCarousel">
            <div class="col col-12 px-md-5">
                <carousel
                    :carousel-settings="carouselSettings">
                    <div v-for="(stream, index) in streams" :key="index">
                        <stream-card
                            :logo="companyLogo.logo"
                            :title="stream.name"
                            :illustration="stream.illustration.url"
                            :button-text="trans('streams.dashboard.start_now')"
                            :button-secondary-text="trans('streams.dashboard.read_more')"
                            :button-disabled="buttonDisabled"
                            @ctaClicked="handleStreamSelection(stream)"
                            @secondaryClicked="goToStreamDetail(stream.id)"
                        />
                    </div>
                </carousel>
            </div>
        </div>
        <div class="row justify-content-center mb-5 px-md-5" v-else>
            <div class="col-12 px-3 px-md-0" 
                :class="totalStreams>2 ? 'col-md-4' : 'col-md-6'"
                v-for="(stream, index) in streams" :key="index">
                <stream-card
                    :logo="companyLogo.logo"
                    :title="stream.name"
                    :illustration="stream.illustration.url"
                    :button-text="trans('streams.dashboard.start_now')"
                    :button-secondary-text="trans('streams.dashboard.read_more')"
                    :button-disabled="buttonDisabled"
                    @ctaClicked="handleStreamSelection(stream)"
                    @secondaryClicked="goToStreamDetail(stream.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import roleMixin from "../mixins/roleMixin";
    import Carousel from '../molecules/Carousel';
    import StreamCard from '../molecules/cards/StreamCard';
    import { mapGetters } from 'vuex';

    export default {
        name: "ServiceListStream",
        components: { Carousel, StreamCard },
        props: {
            streams: Array,
            buttonDisabled: Boolean,
            showCarousel: Boolean,
            totalStreams: Number
        },
        data(){
            return{
                carouselSettings: {
                    "arrows": true,
                    "dots": true,
                    "speed": 500,
                    "slidesToShow": 3,
                    "slidesToScroll": 1,
                    "initialSlide": 0,
                    "infinite": false,
                    "responsive": [
                        {
                            "breakpoint": 1025,
                            "settings": {
                                "slidesToShow": 2
                            }
                        },
                        {
                            "breakpoint": 720,
                            "settings": {
                                "slidesToShow": 1,
                                "arrows": false
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            ...mapGetters({
                companyLogo: 'user/getCompanyInfo'
            })
        },
        methods: {
            goToStreamDetail(idStream){
                this.$emit('onAction', { actionType: 'moreInfo', serviceType: 'stream', serviceId: idStream });
                this.$router.push({name: 'stream-detail', params: { id: idStream} });
            },
            handleStreamSelection(stream){
                this.$emit('onAction', { actionType: 'access', serviceType: 'stream', serviceId: stream.id });
                this.checkService(stream.id, stream.serviceType);
            }
        },
        mixins:[roleMixin]
    }
</script>
